import React, { useEffect, useState } from "react";
import Select from "react-select";
import Fuse from "fuse.js";
import { socket } from "../../../../../socket/socketClient";

const createFuseFilter = (optionsList, keys) => {
	const fuse = new Fuse(optionsList, {
		keys,
		threshold: 0.3,
		ignoreLocation: true,
		includeScore: false,
		useExtendedSearch: true,
	});

	return (candidate, input) => {
		if (!input) return true;
		const results = fuse.search(input);
		return results.some((res) => res.item.value === candidate.value);
	};
};

const MeetingMembersSelect = ({
	meetingId,
	optionsRS,
	optionsEXT,
	values,
	setFieldValue,
	open,
}) => {
	const [membersRS, setMembersRS] = useState(values.membersRS || []);
	const [membersEXT, setMembersEXT] = useState(values.membersEXT || []);

	useEffect(() => {
		setMembersRS(values.membersRS || []);
		setMembersEXT(values.membersEXT || []);
	}, [values.membersRS, values.membersEXT]);

	const handleChange = (field, selected) => {
		setFieldValue(field, selected);
		if (socket.connected && meetingId) {
			socket.emit("update_meeting_field", {
				meetingId,
				field,
				value: selected,
			});
		}
	};

	return (
		<div className="w-full flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
			<div className="w-full relative">
				<label className="text-black text-base absolute left-0 font-bold">
					Usuarios de Ramirez Soto
				</label>
				<br />
				<Select
					isMulti
					name="membersRS"
					options={optionsRS}
					className="basic-multi-select border-2 border-black rounded-lg"
					classNamePrefix="select"
					value={membersRS}
					onChange={(selected) => handleChange("membersRS", selected)}
					placeholder="Selecciona miembros..."
					filterOption={createFuseFilter(optionsRS, ["label"])}
				/>
			</div>
			<div className="w-full relative">
				<label className="text-black text-base absolute left-0 font-bold">
					Usuarios de la empresa
				</label>
				<br />
				<Select
					isMulti
					name="membersEXT"
					options={optionsEXT}
					className="basic-multi-select border-2 border-black rounded-lg"
					classNamePrefix="select"
					value={membersEXT}
					onChange={(selected) => handleChange("membersEXT", selected)}
					placeholder="Selecciona miembros..."
					filterOption={createFuseFilter(optionsEXT, ["label"])}
					noOptionsMessage={() => (
						<div className="text-sm text-gray-500">
							No hay opciones.{" "}
							<button
								type="button"
								onClick={open}
								className="text-blue-600 underline ml-1"
							>
								¿Agregar nuevo?
							</button>
						</div>
					)}
				/>
			</div>
		</div>
	);
};

export default MeetingMembersSelect;
